import FunctionalButton from "components/layout/FunctionalButton";
import Spinner from "components/layout/loading/Spinner";

const MapViewFallback = ({ loading = false, onCreateClick, onChooseClick }) => {
    if (loading) {
        return (
            <div className="flex h-full w-full flex-col items-center justify-center space-y-4">
                <Spinner className="h-8 w-8" />
            </div>
        );
    }

    return (
        <div className="flex h-full w-full flex-col items-center justify-center space-y-4">
            <p className="text-sm text-black60">No map available</p>
            {onCreateClick && (
                <FunctionalButton
                    className="w-16 rounded-r5 bg-black60 px-2 py-1"
                    title="Create"
                    onClick={onCreateClick}
                />
            )}
            {onChooseClick && (
                <FunctionalButton
                    className="w-16 rounded-r5 bg-black60 px-2 py-1"
                    title="Choose"
                    onClick={onChooseClick}
                />
            )}
        </div>
    );
};

export default MapViewFallback;
